import { render, staticRenderFns } from "./conceptgroups-modal-basic-form.vue?vue&type=template&id=0d1e0020&scoped=true&"
import script from "./conceptgroups-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./conceptgroups-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./conceptgroups-modal-basic-form.scss?vue&type=style&index=0&id=0d1e0020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1e0020",
  null
  
)

export default component.exports